import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../core/utils';
import { primaryCalculatorId, selectFinancialCalculator } from '../../core/reducers/financialCalculators';
// TODO; add unit test
const useDynamicTooltip = (calculatorId = primaryCalculatorId) => {
    var _a;
    const { t } = useTranslation();
    const { includeFees, overriddenIsSellingProvince } = (_a = useAppSelector(state => selectFinancialCalculator(state, calculatorId))) !== null && _a !== void 0 ? _a : {};
    let sellingPriceTooltipLabel = t('Shared.Common.sellingPriceTooltipLabel');
    if (overriddenIsSellingProvince && includeFees) {
        sellingPriceTooltipLabel = t('Shared.Common.sellingPriceWithTaxTooltipLabel');
    }
    else if (!overriddenIsSellingProvince) {
        sellingPriceTooltipLabel = t('Shared.Common.sellingPriceStartingFromTooltipLabel');
    }
    return { overrideShowSellingPrice: overriddenIsSellingProvince, sellingPriceTooltipLabel };
};
export default useDynamicTooltip;
